import {createContext} from 'react'

export const LinksContext = createContext({});
